import {injectEndpoints} from '../api/apiSlice';

const extendedApi = injectEndpoints({
  endpoints: (build) => ({
    trackSearchSelection: build.mutation<
      void,
      {searchRunId: string; mediaLibraryAssetId: number; selectedAt: Date}
    >({
      query: ({searchRunId, mediaLibraryAssetId, selectedAt}) => ({
        url: `/media/search-run/${searchRunId}/results/${mediaLibraryAssetId}`,
        method: 'PATCH',
        body: {selectedAt},
      }),
    }),
  }),
});

export const {useTrackSearchSelectionMutation} = extendedApi;
